import React from "react";
import _ from "lodash";
import { Col, Container, Row } from "reactstrap";
import closeIcon from "../../../../assets/images/bingo/cross-icon.png";

const HowToPlay = (props) => {
  const parameters = _.get(props.paramsReducerr, "2_preplay");

  return (
    <>
      <div className="bingo-how-to-play">
        <div className="bingo-how-to-play-modal">
          <img onClick={() => props.toggleHowToPlay()} src={closeIcon} className="close-icon" alt="close icons" />
          <div className="bingo-how-to-play-dialog">
            <h2>how to play</h2>
            <p className="desc">{parameters?.how_text[0]}</p>
            <p className="desc">{parameters?.how_text[1]}</p>
            <p className="desc">{parameters?.how_text[2]}</p>
            <p className="desc">{parameters?.how_text[3]}</p>
            <p className="desc">{parameters?.how_text[4]}</p>
            {/* <p className="desc">
              Sem et tortor consequat id porta. Diam vel quam elementum pulvinar. Amet cursus sit amet dictum sit amet
              justo donec. Quis hendrerit dolor magna eget est lorem. Amet luctus venenatis lectus magna. A diam
              sollicitudin tempor id eu nisl nunc mi ipsum. Dictum varius duis at consectetur lorem. Tincidunt augue
              interdum velit euismod in pellentesque massa placerat.{" "}
            </p>
            <p className="desc">
              Sem et tortor consequat id porta. Diam vel quam elementum pulvinar. Amet cursus sit amet dictum sit amet
              justo donec. Quis hendrerit dolor magna eget est lorem. Amet luctus venenatis lectus magna. A diam
              sollicitudin tempor id eu nisl nunc mi ipsum. Dictum varius duis at consectetur lorem. Tincidunt augue
              interdum velit euismod in pellentesque massa placerat.{" "}
            </p>
            <p className="desc">
              Sem et tortor consequat id porta. Diam vel quam elementum pulvinar. Amet cursus sit amet dictum sit amet
              justo donec. Quis hendrerit dolor magna eget est lorem. Amet luctus venenatis lectus magna. A diam
              sollicitudin tempor id eu nisl nunc mi ipsum. Dictum varius duis at consectetur lorem. Tincidunt augue
              interdum velit euismod in pellentesque massa placerat.{" "}
            </p> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default HowToPlay;
